import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.sass']
})
export class RadioButtonGroupComponent implements OnInit {
  @Input() config: IFieldConfig;
  @Input() group: FormGroup;
  @Input() typeCes?: TypeCesEnum | undefined;

  constructor() { }

  ngOnInit(): void {
     // Desabilita se for modo SHOW
     if (this.typeCes === TypeCesEnum.SHOW) {
       this.group.get(this.config.name)?.disable();
     }
  }

   // Helper para verificar se o controle está desabilitado
   get isDisabled(): boolean {
    return this.group.get(this.config.name)?.disabled ?? false;
  }
} 